import { render, staticRenderFns } from "./VehicleStatusConfiguration.vue?vue&type=template&id=abaadf96&"
import script from "./VehicleStatusConfiguration.vue?vue&type=script&lang=js&"
export * from "./VehicleStatusConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports